// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const Timeline = (el) => {
  const ui = {
    el,
    body: select('body', document),
    items: select.all('.timeline__item', el),
  };



  const setCurrentItem = (current) => {
    ui.items.forEach((item) => {
      item.setAttribute('data-current', item === current ? 'true' : 'false');
    });
  };

  const handleScrollIntoView = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setCurrentItem(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -80% 0px',
      threshold: 0,
    });

    ui.items.forEach((item) => observer.observe(item));
  };

  const addEvents = () => {
    setCurrentItem(ui.items[0]);
    handleScrollIntoView();
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default Timeline;
